import React from 'react';
import PropTypes from 'prop-types';

function BriefcaseIcon({ className = 'h-4 w-4' }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.75'
      strokeLinecap='round'
      strokeLinejoin='round'
      className={className}
    >
      <rect x='2' y='7' width='20' height='14' rx='2' />
      <path d='M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2' />
      <path d='M12 12v4' />
      <path d='M10 14h4' />
    </svg>
  );
}

BriefcaseIcon.propTypes = {
  className: PropTypes.string,
};

export default BriefcaseIcon;
